import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import formatPhoneUS from './helpers/formatPhoneUS';
import ApiServiceDGB from './shared/ApiServiceDGB';
import { Toaster } from 'react-hot-toast';
import { notifyError, notifySuccess } from './ToastMessages';
import { validTypes } from "./helpers/validDGBFileType";
import FileUploadArea from "./DGBComponents/FileUploadArea";
import FileUploadPreview from "./DGBComponents/FileUploadPreview";

const PhoneRow = ({
    phoneId,
    userId,
    phone,
    lastSentMsg,
    status,
    onChange,
    readOnly,
    saveNumber,
    sendTextMessage,
    deletePhoneNumber,
    approveNumber,
    removePhoneRow
}) => {
    let lastMsgSentDate;
    const [originalPhone, setOriginalPhone] = useState(phone);
    const [currentPhone, setCurrentPhone] = useState(phone);
    const [formattedLastMsgDate, setFormattedLastMsgDate] = useState(null);

    useEffect(() => {
        setOriginalPhone(formatPhoneUS(phone));
    }, []);

    useEffect(() => {
        setCurrentPhone(formatPhoneUS(phone));
    }, [phone]);

    const handleInputChange = (event) => {
        setCurrentPhone(formatPhoneUS(event.target.value));
        onChange(event, phoneId);
    };

    useEffect(() => {
        if (lastSentMsg) {
            lastMsgSentDate = new Date(lastSentMsg);
            const options = {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            };

            setFormattedLastMsgDate(!isNaN(lastMsgSentDate.getTime()) ? lastMsgSentDate.toLocaleString('en-US', options) : 'not sent yet');
        }
    }, [lastSentMsg]);


    const handleSave = (phone) => async () => {
        try {
            await saveNumber(phone, userId, phoneId);
            setOriginalPhone(currentPhone);
        } catch (error) {
            console.error('Error saving phone number:', error);
        }
    };

    const handleApprove = (userId, phoneId) => async () => {
        approveNumber(userId, phoneId);
    }

    const sendText = (phoneId, userId) => async () => {
        await sendTextMessage(phoneId, userId);
        const now = new Date(); // Get the current date and time
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        };
        setFormattedLastMsgDate(now.toLocaleString('en-US', options));
    }

    const deletePhone = (userId) => async () => {
        deletePhoneNumber(userId);
    }

    return (
        <>
            <div className="d-flex flex-column">
                <div className="input-group feedback-form-control w-50 mr-3 dgb-input dgb-input--phone">
                    <input
                        placeholder={__('Add a new phone number')}
                        type="tel"
                        className="form-control input mr-2 w-50"
                        value={formatPhoneUS(phone) || ''}
                        maxLength={14}
                        pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                        onChange={handleInputChange}
                        readOnly={readOnly}
                        onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                            }
                        }}
                    />
                </div>
                {lastSentMsg &&
                    <span>{ __('Last sent message at')}: {formattedLastMsgDate}</span>
                }
            </div>

            {(status !== 'pending' && phoneId) &&
                <button
                    className='btn btn-xs text-nowrap btn-primary ml-3 mr-3'
                    onClick={sendText(phoneId, userId)}
                    disabled={status === 'pending'}
                >
                    <i className='fas fa-paper-plane mr-1'></i>
                    {__('Send text registration message')}
                </button>
            }

            {/* Save or Approve */}
            {status === 'pending' && phoneId
                ?
                <button
                    className='btn btn-xs btn-primary mr-1'
                    onClick={handleApprove(userId, phoneId)}
                >
                    <i className='fas fa-save mr-1'></i>
                    {__('Approve')}
                </button>
                :
                    currentPhone !== originalPhone &&
                        <button
                            className='btn btn-xs btn-primary mr-1'
                            onClick={handleSave(phone)}
                        >
                            <i className='fas fa-save mr-1'></i>
                            {__('Save')}
                        </button>

            }

            {userId &&
                <button
                    onClick={deletePhone(userId)}
                    className='btn btn-xs btn-danger mr-1'
                    disabled={!userId}
                >
                    <i className='fas fa-trash mr-1'></i>
                    {__('Delete phone number')}
                </button>
            }

            {status === 'pending' && !userId &&
                <button
                    onClick={removePhoneRow}
                    className='btn btn-xs btn-danger mr-1'
                >
                    <i className="fas fa-minus-circle mr-2"></i>
                    {__('Remove')}
                </button>
            }
        </>
    );
}

class EditVin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dgbApiUrl: this.props.state.dgbApiUrl,
            id: '',
            vin: '',
            make: '',
            model: '',
            year: '',
            users: [],
            phoneNumbers: [],
            uploadedFiles: [],
            existingFiles: [],
            displayColumn: '2',
            showDeleteModal: false,
            deleteFileId: null,
            isAddingNewNumber: false,
            // phone search
            disabledSave: true,
            checkingPhone: false,
            verifiedPhoneExists: false,
            existingUser: [],
        };

        this.apiService = new ApiServiceDGB(this.state.dgbApiUrl, this.props.state.jwt);

        this.handleUploadFiles = this.handleUploadFiles.bind(this);
        this.triggerDeleteFileModal = this.triggerDeleteFileModal.bind(this);
        this.handleDeleteFile = this.handleDeleteFile.bind(this);
        this.deleteFile = this.deleteFile.bind(this);
        this.sendTextMessage = this.sendTextMessage.bind(this);
        this.approveNumber = this.approveNumber.bind(this);
        this.removePhoneRow = this.removePhoneRow.bind(this);
    }

    componentDidMount() {
        this.getVinDetails();

        // init debt tooltip
        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
    }

    getVinDetails = async () => {
        const {vin} = this.props;
        const businessRef = this.props.state.business.reference;

        try {
            const data = await this.apiService.getVinDetails(businessRef, vin);

            this.setState({
                id: data.items[0]["_id"],
                vin: data.items[0].vin,
                make: data.items[0].make,
                model: data.items[0].model,
                year: data.items[0].year,
                existingFiles: data.items[0].attachments,
                users: data.items[0].users
            });
        } catch (error) {
            console.error('Error fetching VIN details:', error);
        }
    };

    searchPhone = async (phone) => {
        const businessRef = this.props.state.business.reference;

        this.setState({
            checkingPhone: true
        });

        try {
            const response = await this.apiService.searchPhoneNumber(businessRef, phone);

            if (response[0]["_id"]) {
                this.setState({
                    checkingPhone: false,
                    verifiedPhoneExists: true,
                    existingUser: response,
                    disabledSave: false
                });
            }

        } catch (error) {
            console.log('Error checking phone number', error);
            this.setState({
                checkingPhone: false,
                verifiedPhoneExists: false,
                existingUser: [],
                disabledSave: false
            });

        }
    }

    handlePhoneChange = async (userIndex, phoneIndex, event, phoneId, isExisting) => {
        const value = event.target.value;

        if (value.length === 14) {
            await this.searchPhone(value);
        }

        this.setState((prevState) => {
            if (!isExisting) {
                // Update phoneNumbers array
                const newPhoneNumbers = [...prevState.phoneNumbers];
                if (newPhoneNumbers[phoneIndex]) {
                    newPhoneNumbers[phoneIndex] = { ...newPhoneNumbers[phoneIndex], phoneNumber: value };
                }
                return { phoneNumbers: newPhoneNumbers };
            } else {
                // Update users array
                const newUsers = [...prevState.users];
                const user = { ...newUsers[userIndex] };

                const phones = user.phones.map((phone, index) =>
                    index === phoneIndex ? { ...phone, phoneNumber: value } : phone
                );
                user.phones = phones;
                newUsers[userIndex] = user;

                return { users: newUsers };
            }
        });
    };

    addPhoneRow = () => {
        this.setState(prevState => {
            const hasEmptyRow = prevState.phoneNumbers.some(phone => phone.phoneNumber === '' && phone.status === 'pending');
            if (!hasEmptyRow) {
                return {
                    phoneNumbers: [...prevState.phoneNumbers, { phoneNumber: '', status: 'pending' }],
                    isAddingNewNumber: true
                };
            }
            return null;
        });
    }

    removePhoneRow = () => {
        this.setState(prevState => ({
            phoneNumbers: prevState.phoneNumbers.filter(phone => phone.phoneNumber !== '' && phone.status !== 'pending'),
            isAddingNewNumber: false
        }));
    }

    handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        const invalidFiles = files.filter(file => !validTypes.includes(file.type));

        if (invalidFiles.length > 0) {
            notifyError(__('Unsupported file type(s):') + `${invalidFiles.map(file => file.name).join(", ")}`);
            event.target.value = "";
            return;
        }

        if (files && files.length > 0) {
            const uploadedFiles = files.map((file) => ({
                name: file.name,
                type: file.type,
                url: URL.createObjectURL(file),
                fileObject: file
            }));

            this.setState((prevState) => ({
                uploadedFiles: [...prevState.uploadedFiles, ...uploadedFiles],
            }));
        }
    };

    removeImg = (index) => () => {
        this.setState((prevState) => {
            const uploadedFiles = [...prevState.uploadedFiles];
            uploadedFiles.splice(index, 1);
            return { uploadedFiles: uploadedFiles };
        });
    };

    // delete already existing document
    triggerDeleteFileModal = (file) => {
        this.setState({
            showDeleteModal: true,
            deleteFileId: file.id
        });
    }

    handleDeleteFile = (isDelete) => {
        if (!isDelete) {
            this.setState({ showDeleteModal: false });
            return null;
        } else {
            this.deleteFile();
        }
    }

    deleteFile = async () => {
        const { id, deleteFileId } = this.state;

        try {
            const response = await this.apiService.deleteFile(id, deleteFileId);
            this.setState({
                existingFiles: response.attachments,
                showDeleteModal: false,
                deleteFileId: ''
            });
            notifySuccess(__('Document deleted successfully'));
        } catch (error) {
            console.error('Error deleting VIN:', error);
        }
    }

    handleUploadFiles = async () => {
        const { id, uploadedFiles } = this.state;

        const formData = new FormData();
        if (uploadedFiles.length > 0) {
            uploadedFiles.forEach((file) => {
                formData.append('files', file.fileObject);
            });
        }

        try {
            const response = await this.apiService.uploadFiles(id, formData);
            this.setState({
                existingFiles: response.attachments,
                uploadedFiles: []
            });
            notifySuccess(__('Files uploaded successfully'));

        } catch (error) {
            console.error('Error uploading files:', error);
        }
    }

    // New Phone Number
    saveNewPhoneNumber = async (phoneNumber) => {
        const carId = this.state.id;
        const USPhone = "+1" + phoneNumber.replace(/\D/g, '');

        try {
            let response;
            if (this.state.existingUser.length > 0) {
                response = await this.apiService.addPhoneNumberForExistingUser(carId, this.state.existingUser[0]["_id"]);
            } else {
                response = await this.apiService.addPhoneNumber(carId, USPhone);
            }

            if (response.ok) {
                notifySuccess(__('New phone number saved successfully'));
                // remove the current phone number
                const newPhoneNumbers = this.state.phoneNumbers.filter(phone => phone.phoneNumber !== phoneNumber);
                this.setState({ phoneNumbers: newPhoneNumbers });

                // update the list of phones
                this.getVinDetails();
            }

        } catch (error) {
            console.error('Error saving new phone number:', error);
            notifyError(__('Error saving new phone number'));
        }
    }

    //
    approveNumber = async (userId, phoneId) => {
        try {
            const response = await this.apiService.approvePhoneNumber(userId, phoneId);

            if (response.ok) {
                notifySuccess(__('Phone number approved successfully'));

                // update the list of phones
                this.getVinDetails();

            }
        } catch (error) {
            console.error('Error saving new phone number:', error);
        }
    }

    updatePhoneNumber = async (phoneNumber, userId, phoneId) => {
        const USPhone = "+1" + phoneNumber.replace(/\D/g, '');

        try {
            const response = await this.apiService.editPhoneNumber(
                userId,
                phoneId,
                USPhone
            );

            notifySuccess(__('Phone number successfully updated'));
        } catch (error) {
            console.error('API Error:', error.message);
            notifyError(error.message);
            throw error;
        }
    }

    // Delete Phone Number
    deletePhoneNumber = async (userId) => {
        const carId = this.state.id;

        try {
            const response = await this.apiService.deletePhoneNumber(carId, userId);

            if (response.ok) {
                notifySuccess(__('Phone number deleted successfully'));
                this.getVinDetails();
            }
        } catch (error) {
            console.error('Error fetching VIN details:', error);
        }
    }

    // Send Text Message
    sendTextMessage = async (phoneId, userId) => {
        const businessRef = this.props.state.business.reference;

        try {
            const response = await this.apiService.postTextMessage(
                businessRef,
                userId,
                phoneId
            );

            notifySuccess(__('Text message sent successfully'));
        } catch (error) {
            console.error('Error fetching VIN details:', error);
        }
    }

    render() {
        const hasUnapprovedPhones = this.state.users.some(user =>
            user.phones.some(phone => phone.approvedAt === null)
        );

        const goToManage = () => {
            const currentPath = window.location.pathname;
            const newPath = currentPath.split('/').slice(0, -1).join('/');
            window.location.href = newPath;
        };

        return (
            <div className="edit-vin w-100 right-side-content pb-5">
                <div className="main-section">
                    <div className="w-100 p-2 bg-white border-bottom d-flex align-items-center p-3">
                        <button className="btn btn-outline-primary ml-2 mr-3 text-nowrap"
                                onClick={goToManage}>{__('Back to Manage VINs')}</button>
                        <p className='mb-0 w-100'>{__('Currently editing a VIN')}.</p>
                    </div>
                </div>

                <div className="w-100 p-2 bg-white d-flex flex-column align-items-start p-3">
                    <p className="dgb-car-info-text">{__('Currently Editing:')} <strong>{this.props.vin}</strong></p>
                    <p className="d-flex flex-column dgb-car-info-text">
                        <span>{__('Make')}: {this.state.make ?? 'N/A'}</span>
                        <span>{__('Model')}: {this.state.model ?? 'N/A'}</span>
                        <span>{__('Year')}: {this.state.year ?? 'N/A'}</span>
                    </p>

                    {/* Authorized Cell Numbers List */}
                    <h5 className="mt-5">{__('Authorized cell numbers')}</h5>
                    <div className="w-100 d-flex align-items-start">
                        <ul className="d-flex flex-column p-0 m-0 w-100">
                            {/* Show only phones with approvedAt value */}
                            {this.state.users.map((user, userIndex) => {
                                const approvedPhones = user.phones.filter(phone => phone.approvedAt);
                                if (approvedPhones.length > 0) {
                                    return approvedPhones.map((data, phoneIndex) => (
                                        <li key={`${userIndex}-${phoneIndex}`}
                                            className="d-flex flex-row list-style-none p-0 m-0 mt-2 mb-2 w-100 dgb-phonerow">
                                            <PhoneRow
                                                phoneId={data["_id"]}
                                                userId={user["_id"]}
                                                phone={data.phoneNumber}
                                                lastSentMsg={user.sentMessages.length > 0 ? user.sentMessages[0].sentAt : 'N/A'}
                                                status={(data && data.approvedAt && data?.approvedAt?.length > 0) ? "" : "pending"}
                                                onChange={(event) => this.handlePhoneChange(userIndex, phoneIndex, event, data["_id"], true)}
                                                saveNumber={this.updatePhoneNumber}
                                                sendTextMessage={this.sendTextMessage}
                                                deletePhoneNumber={this.deletePhoneNumber}
                                                approveNumber={this.approveNumber}
                                            />
                                        </li>
                                    ));
                                } else {
                                    return (
                                        <span>{ __('No Authorized Cell Numbers for this User') }</span>
                                    )
                                }
                                return null;
                            })}

                            <li className="d-flex flex-row list-style-none p-0 mt-4">
                                <button
                                    className="btn btn-xs btn-outline-primary"
                                    onClick={this.addPhoneRow}
                                >
                                    <i className="fas fa-plus-circle mr-1"></i>
                                    {__('Add Cell Number')}
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* Pending Cell Numbers List */}
                    {(hasUnapprovedPhones || this.state.isAddingNewNumber) &&
                        <>
                            <h5 className="mt-5">{__('Pending to authorize cell numbers')}</h5>
                            <div className="w-100 d-flex align-items-start">
                                <ul className="d-flex flex-column p-0 m-0 w-100">
                                        {this.state.users.map((user, userIndex) => {
                                            const unapprovedPhones = user.phones.filter(phone => phone.approvedAt === null);
                                            return unapprovedPhones.length > 0 ? (
                                                unapprovedPhones.map((data, phoneIndex) => (
                                                    <li key={`pending-${userIndex}-${phoneIndex}`}
                                                        className="d-flex flex-row list-style-none p-0 m-0 mt-2 mb-2 w-100 dgb-phonerow">
                                                        <PhoneRow
                                                            phoneId={data["_id"]}
                                                            userId={user["_id"]}
                                                            phone={data.phoneNumber}
                                                            lastSentMsg={user.sentMessages.length > 0 ? user.sentMessages[0].sentAt : 'N/A'}
                                                            status="pending"
                                                            onChange={(event) => this.handlePhoneChange(userIndex, phoneIndex, event, data["_id"], true)}
                                                            saveNumber={this.updatePhoneNumber}
                                                            sendTextMessage={this.sendTextMessage}
                                                            deletePhoneNumber={this.deletePhoneNumber}
                                                            approveNumber={this.approveNumber}
                                                        />
                                                    </li>
                                                ))
                                            ) : null;
                                        })}

                                        {this.state.phoneNumbers.map((phone, index) => (
                                            <li key={index}
                                                className="d-flex flex-row list-style-none p-0 m-0 mt-2 mb-2 w-100 dgb-phonerow">
                                                <PhoneRow
                                                    phoneId={null}
                                                    userId={null}
                                                    phone={phone.phoneNumber}
                                                    lastSentMsg={null}
                                                    status={phone.status}
                                                    onChange={(event) => this.handlePhoneChange(null, index, event, null, false)}
                                                    saveNumber={this.saveNewPhoneNumber}
                                                    sendTextMessage={this.sendTextMessage}
                                                    deletePhoneNumber={this.deletePhoneNumber}
                                                    approveNumber={this.approveNumber}
                                                    removePhoneRow={this.removePhoneRow}
                                                />
                                            </li>
                                        ))}
                                    </ul>
                            </div>
                        </>
                    }


                    {/* Files */}
                    <div className="d-flex flex-column mt-3">
                        <h5 className="mt-5">{__('Upload New Documents')}</h5>
                        <div className='dgb-upload-component'>
                            <div className="dgb-upload-wrapper">
                                <input
                                    onChange={this.handleFileChange}
                                    className="dgb-upload-input"
                                    type="file"
                                    accept="image/* application/pdf"
                                    name="file"
                                    id="file-upload"
                                    multiple
                                />

                                {this.state.uploadedFiles && this.state.uploadedFiles.length > 0 ? (
                                    <ul className="attachments-preview-wrapper">
                                        {this.state.uploadedFiles.map((img, i) => (
                                            <li key={i}>
                                                {img.type.includes('image') ? (
                                                    <>
                                                        <img src={img.url} alt={`Attachment ${i}`}/>
                                                        <small>{img.name}</small>
                                                    </>
                                                ) : (
                                                    <FileUploadPreview img={img} />
                                                )}

                                                <button onClick={this.removeImg(i)}>
                                                    <svg
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 13 13"
                                                    >
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M.293 1.293a1 1 0 0 1 1.414 0L6 5.586l4.293-4.293a1 1 0 1 1 1.414 1.414L7.414 7l4.293 4.293a1 1 0 0 1-1.414 1.414L6 8.414l-4.293 4.293a1 1 0 0 1-1.414-1.414L4.586 7 .293 2.707a1 1 0 0 1 0-1.414Z"
                                                            fill="#FEFEFE"
                                                            fillOpacity=".996"
                                                        />
                                                    </svg>
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <FileUploadArea />
                                )}

                                {/* Upload Button */}
                                {this.state.uploadedFiles && this.state.uploadedFiles.length > 0 && (
                                    <button
                                        type='submit'
                                        onClick={this.handleUploadFiles}
                                        className="btn btn-sm btn-primary dgb-upload-button"
                                    >
                                        {__('Upload')}
                                    </button>
                                )}
                            </div>
                        </div>

                    </div>

                    {/* Already Saved Docs */}
                    <div className="d-flex flex-column w-100 mt-3">
                        {this.state.existingFiles?.length > 0 &&
                            <>
                                <h5 className="mt-5">{__('Uploaded Documents')}</h5>

                                {/* Display Toggle */}
                                <div className="dgb-upload-display" data-selected={this.state.displayColumn}>
                                    <span>{__('Display')}:</span>
                                    <button className="dgb-toggle-button"
                                            onClick={() => this.setState({displayColumn: '2'})}>
                                        <svg
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 16 13"
                                        >
                                            <g opacity=".6" fill="#353535">
                                                <path d="M7.2.5v5.25H0V.5zM7.2 7.25v5.25H0V7.25z"/>
                                            </g>
                                            <g opacity=".6" fill="#353535">
                                                <path d="M16 .5v5.25H8.8V.5zM16 7.25v5.25H8.8V7.25z"/>
                                            </g>
                                        </svg>
                                    </button>
                                    <button className="dgb-toggle-button"
                                            onClick={() => this.setState({displayColumn: '1'})}>
                                        <svg
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 16 13"
                                        >
                                            <path
                                                fill="#353535"
                                                d="M16 .5v12H0V.5z"
                                                opacity=".6"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </>
                        }

                        {/* Files */}
                        <div className="dgb-files-list" data-column={this.state.displayColumn}>
                            <ul>
                                {this.state.existingFiles?.map((file, index) => {
                                    return (
                                    <li key={index}>
                                        <a href={file.url} target="_blank" rel="noopener noreferrer">
                                            <span>{file.originalName ? file.originalName + '.' + file.extension : ''}</span>
                                            <br/>
                                            <span><strong>{__('Added By:')} </strong>{file.uploadedBy ? file.uploadedBy?.firstName + " " + file.uploadedBy?.lastName : 'N/A'}</span>
                                            {file && file?.extension === 'pdf' ? (
                                                <object id="myPdf" type="application/pdf" data={file.url}>
                                                    <svg fill="none" xmlns="http://www.w3.org/2000/svg"
                                                         viewBox="0 0 800 800">
                                                        <g clipPath="url(#a)" fill="#020202">
                                                            <path
                                                                d="M321.621 185.77H205.519c-17.896 0-32.405 14.509-32.405 32.405 0 17.895 14.509 32.404 32.405 32.404h116.102c17.896 0 32.405-14.509 32.405-32.404 0-17.896-14.509-32.405-32.405-32.405ZM321.621 320.43H205.519c-17.896 0-32.405 14.508-32.405 32.404 0 17.896 14.509 32.405 32.405 32.405h116.102c17.896 0 32.405-14.509 32.405-32.405s-14.509-32.404-32.405-32.404ZM457.861 547.319v31.558h16.671c20.218 0 20.219-12.096 20.219-16.071 0-3.834-.001-15.489-20.219-15.489h-16.671v.002Z"/>
                                                            <path
                                                                d="M703.994 487.691h-52.733V159.22c0-8.498-3.37-16.645-9.384-22.648L514.687 9.374A32.051 32.051 0 0 0 492.039 0H109.267C74.588 0 46.379 28.211 46.379 62.89v674.217c0 34.682 28.211 62.893 62.888 62.893h479.104c34.677 0 62.888-28.213 62.888-62.893v-64.912h52.733c27.407 0 49.628-22.219 49.628-49.629v-85.249c.002-27.406-22.218-49.626-49.626-49.626ZM582.966 729.976H114.672V70.024h332.876v94.137c0 22.802 18.479 41.276 41.272 41.276h94.146v282.254H422.719c-27.409 0-49.628 22.22-49.628 49.628v85.25c0 27.409 22.219 49.628 49.628 49.628h160.247v57.779Zm-67.715-167.17c0 22.556-15.606 36.57-40.721 36.57h-16.671v19.393c0 5.003-4.055 9.066-9.063 9.066h-2.37c-5.009 0-9.066-4.063-9.066-9.066v-82.882c0-5.003 4.057-9.067 9.066-9.067h28.104c25.117-.002 40.721 13.785 40.721 35.986Zm51.404 65.029h-32.609a9.068 9.068 0 0 1-9.067-9.066v-82.882c0-5.003 4.055-9.067 9.067-9.067h32.609c28.404 0 51.513 22.683 51.513 50.57 0 27.816-23.107 50.445-51.513 50.445Zm129.942-89.585a9.063 9.063 0 0 1-9.067 9.067h-36.822v21.717h31.37c5.005 0 9.067 4.051 9.067 9.063v2.374c0 5.003-4.062 9.067-9.067 9.067h-31.37v29.228c0 5.004-4.055 9.067-9.064 9.067h-2.368a9.066 9.066 0 0 1-9.067-9.067v-82.881a9.066 9.066 0 0 1 9.067-9.067h48.254c5.01 0 9.067 4.063 9.067 9.067v2.365Z"/>
                                                            <path
                                                                d="M566.656 547.319h-21.177v60.017h21.177c17.099 0 31.011-13.441 31.011-29.946.002-16.582-13.91-30.071-31.011-30.071Z"/>
                                                        </g>
                                                        <defs>
                                                            <clipPath id="a">
                                                                <path fill="#fff" d="M0 0h800v800H0z"/>
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </object>
                                            ) : (
                                                <img src={file.url || file} alt={`Attachment ${index}`}/>
                                            )}
                                        </a>

                                        <div className='dgb-files-actions'>
                                            {/* View */}
                                            <a href={file.url} target="_blank">
                                                <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
                                                    <g fill="#000">
                                                        <path
                                                            d="M6.94129 120c-3.47886-.647-5.92583-2.456-6.7497-6.041-.15053-.655-.16422-1.349-.16696-2.027C.01916 82.6801.02737 53.4253 0 24.1732c0-1.8059.57205-3.2402 1.84481-4.5024C7.81716 13.7504 13.7704 7.80821 19.7044 1.84687 20.9717.57373 22.4388 0 24.2261 0c20.843.0164 41.6833 0 62.5263.01366 5.1321.00273 8.4002 3.24022 8.4358 8.33003.0273 3.72381.0054 7.45031.0054 11.17411v.2732c-.0547 2.0736-1.1632 3.4779-2.7179 3.4451-1.6258-.0355-2.592-1.325-2.5975-3.4915-.0055-3.6801.0082-7.3575-.0055-11.03754-.0082-2.52442-.854-3.38229-3.3392-3.38229-20.479-.00273-40.9553.00273-61.4343-.01912-.9853 0-1.7079.28413-2.4032.98627C17.2821 11.7424 11.8434 17.171 6.38292 22.5777c-.72807.7213-1.07568 1.4616-1.07568 2.508.0219 28.7986.01642 57.5972.0219 86.3933 0 2.609.68427 3.265 3.35021 3.265H86.4951c2.603 0 3.3749-.776 3.3776-3.437.0082-5.224 0-10.448.0055-15.6715 0-.4999-.0219-1.0054.052-1.4971.1834-1.2213 1.229-2.1747 2.4032-2.2512 1.155-.0765 2.2772.7567 2.6495 1.9425.208.6611.2135 1.3387.2135 2.0217 0 4.9506-.0657 9.9036.0191 14.8546.0739 4.223-1.3083 8.13-6.8892 9.297H6.94129V120Z"/>
                                                        <path
                                                            d="M120 93.5592c-.741 2.3824-1.989 4.4014-4.294 5.5516-3.126 1.5622-6.602.9752-9.161-1.56-4.297-4.2538-8.581-8.5186-12.8071-12.8407-.9114-.9316-1.5546-1.06-2.7507-.4153-10.245 5.5379-23.8676 3.9096-32.9438-3.8931-7.1904-6.1827-10.7787-14.1084-10.6719-23.5176.1614-14.2258 10.7431-26.4435 24.7926-28.9898 17.148-3.1063 33.5129 9.136 35.2789 26.4845.596 5.8603-.386 11.5102-3.173 16.753-.569 1.071-.369 1.6502.422 2.4343 4.004 3.9669 7.929 8.0103 11.936 11.9746 1.478 1.4616 2.778 2.9916 3.372 5.0215v2.9998-.0028Zm-17.747-35.8117c.036-13.8761-10.8087-24.8453-24.6037-24.9191-12.952-.0683-24.9268 9.8655-24.9213 24.7797.0054 13.4499 10.3763 24.4628 24.6476 24.6595 13.7074.1913 24.8414-10.8981 24.8804-24.5229l-.003.0028ZM41.6167 97.6599H21.2773c-.8677 0-1.7271 0-2.5072-.4836-1.0073-.6256-1.3987-1.5217-1.2208-2.6665.1697-1.0928.7911-1.8359 1.8804-2.0872.6159-.1421 1.2591-.2268 1.8886-.2268 13.6965-.0137 27.3902-.0137 41.0866 0 .5858 0 1.1852.071 1.7545.2049 1.27.2978 2.0665 1.2786 2.0419 2.5545-.0246 1.284-.75 2.1419-1.9515 2.4971-.6405.1885-1.3467.2021-2.0228.2021-6.8701.0137-13.7402.0082-20.6103.0082v-.0027ZM32.6978 22.6952c0 2.3168.0192 4.6336-.0027 6.9476-.0192 2.06-1.0346 3.1473-3.0875 3.1637-4.6859.041-9.3718.0355-14.0577.0028-1.8749-.0137-3.071-1.1666-3.0355-2.7813.0329-1.5053 1.1414-2.4807 2.9862-2.5025 3.3201-.0356 6.643-.011 9.9631-.0137 1.2755 0 1.9141-.6584 1.9159-1.9753 0-2.997 0-5.9941.0028-8.9912 0-.4535-.0082-.9125.0547-1.3605.2327-1.6283 1.3905-2.7048 2.7837-2.6255 1.4178.0819 2.4442 1.2458 2.4661 2.9123.0328 2.407.0082 4.8139.0082 7.2209l.0027.0027ZM30.8419 77.5631c-3.5473 0-7.0946.0327-10.6391-.0164-1.5656-.0219-2.5948-1.0136-2.6796-2.3687-.0849-1.366.7992-2.4616 2.2937-2.7457.6186-.1175 1.2645-.1394 1.8968-.1394 5.9121-.0109 11.8215-.0054 17.7337-.0054.5446 0 1.0921-.0164 1.6368.0191.635.0437 1.27.1366 1.8283.4754 1.0675.6475 1.4179 1.631 1.1961 2.8058-.2271 1.1939-1.2727 1.9561-2.7617 1.9698-3.5007.0328-7.0015.0109-10.5022.0109v-.0054h-.0028ZM28.766 57.6489c-2.8192 0-5.6357.0137-8.4549-.0082-1.1113-.0082-2.0583-.3852-2.5565-1.478-.4324-.9508-.3394-1.8851.2874-2.6993.6952-.9043 1.7189-1.1174 2.8028-1.1201h10.3654c1.9105 0 3.8183-.0164 5.7288.0109 1.1249.0164 2.1979.2623 2.8356 1.3114 1.1058 1.8222-.1451 3.9205-2.4141 3.9669-2.863.0601-5.726.0137-8.5918.0137l-.0027.0027Z"/>
                                                    </g>
                                                </svg>
                                                { __('View File') }
                                            </a>

                                            {/* Delete */}
                                            <button
                                                onClick={() => this.triggerDeleteFileModal(file)}
                                                disabled={file.uploadedBy.remoteId === null}
                                                data-toggle="tooltip"
                                                data-title={file.uploadedBy.remoteId === null ? 'Documents uploaded by customers may not be deleted by the dealership.' : ''}
                                            >
                                                <i className='fas fa-trash mr-1'></i>
                                                {__('Delete file')}
                                            </button>

                                        </div>
                                    </li>
                                )})}
                            </ul>
                        </div>
                    </div>

                    {/* Delete Modal */}
                    {this.state.showDeleteModal &&
                        <div className='dgb-delete-modal'>
                            <div className='dgb-delete-modal-content'>
                                <h5>{__('Are you sure?')}</h5>
                                <h6>{__('Once you delete a file you cant undo it!')}</h6>

                                <div className='dgb-delete-modal-buttons'>
                                    <button className='btn btn-xs btn-outline-primary mr-3'
                                            onClick={() => this.handleDeleteFile((false))}>{__('Cancel')}</button>
                                    <button className='btn btn-xs btn-primary'
                                            onClick={() => this.handleDeleteFile((true))}>{__('Delete')}</button>
                                </div>
                            </div>
                        </div>
                    }
                </div>

                {/* Toast */}
                <Toaster
                    position="top-center"
                    toastOptions={{
                        duration: 3000,
                    }}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        state: state,
        business: state.business,
        vin: state.current_vin
    }
}

export default connect(mapStateToProps)(EditVin)
